import { httpPost } from "@/services/api.service";
import { NLQ_URL } from "@/common/constants/api";
import { SAVED_SEARCH_BOUND_TYPES } from "@/common/constants/savedSearch";
import { GEOLOCATION_PRECISIONS } from "@/common/constants/geolocationPrecisions.js";

export { _processNLQ as processNLQ };

const _processNLQ = async (query) => {
  try {
    const queryData = { question: query };
    let RESULT = await httpPost({
      url: NLQ_URL,
      data: JSON.parse(JSON.stringify(queryData)),
    });
    const { data } = JSON.parse(RESULT);

    if (data) {
      const searchParams = await _formatNLQResponse(data);
      return searchParams;
    }

    console.error("Issue processsing search NLQ.");
    return null;
  } catch (error) {
    console.error("Unable to process search NLQ", error);
    return false;
  }
};

const _formatNLQResponse = async (data) => {
  // Params coming via API ref: https://seerist.atlassian.net/wiki/spaces/AAAS/pages/3335356417/NLQ+API+Interface
  let formattedResponse = {
    params: {
      search: "",
    },
  };

  if (data?.start && data?.end) {
    formattedResponse.params.start = data.start;
    formattedResponse.params.end = data.end;
  }

  if (!data?.params) {
    formattedResponse.originalResponseData = data;
    return formattedResponse;
  }

  if (data?.params.search && typeof data.params.search === "string") {
    formattedResponse.params.search = data.params.search;
  }

  if (data?.params.bounds && typeof data.params.bounds === "string") {
    formattedResponse.params.bounds = data.params.bounds;
  }

  if (data?.params.boundsType && typeof data.params.boundsType === "string") {
    const boundsType = data.params.boundsType.replace("_", "");
    formattedResponse.params.boundsType =
      SAVED_SEARCH_BOUND_TYPES.indexOf(boundsType) !== -1
        ? boundsType
        : "mapextent";
  }

  if (data?.params.aoiId) {
    formattedResponse.params.aoiId =
      typeof data.params.aoiId === "string"
        ? data.params.aoiId.toUpperCase().split(",")
        : data.params.aoiId;
  }

  if (data?.params.sources) {
    formattedResponse.params.sources =
      typeof data.params.sources === "string"
        ? data.params.sources.split(",")
        : data.params.sources;
  }

  if (data?.params.topics) {
    formattedResponse.params.topics =
      typeof data.params.topics === "string"
        ? data.params.topics.split(",")
        : data.params.topics;
  }

  if (data?.params.eventType) {
    formattedResponse.params.eventType =
      ["all", "detected", "verified"].indexOf(data.params.eventType) !== -1
        ? data.params.eventType
        : "all";
  }

  if (data?.params.geolocationPrecisions) {
    const glp =
      typeof data.params.geolocationPrecisions === "string"
        ? data.params.geolocationPrecisions.split(",")
        : data.params.geolocationPrecisions;
    formattedResponse.params.geolocationPrecisions = GEOLOCATION_PRECISIONS.filter(
      (cur) => {
        const curName = cur.name.replaceAll(" ", "").toLowerCase();
        return glp.includes(curName);
      }
    ).map((precision) => {
      return precision.id;
    });
  }

  if (data?.params.emotions) {
    formattedResponse.params.emotions = Array.isArray(data.params.emotions)
      ? data.params.emotions.join()
      : data.params.emotions;
  }

  if (data?.params.sentiments) {
    formattedResponse.params.sentiments = Array.isArray(data.params.sentiments)
      ? data.params.sentiments.join()
      : data.params.sentiments;
  }

  formattedResponse.originalResponseData = data;
  return formattedResponse;
};
